export interface BugsService {
	reportError(id: string, error: Error, event: { [key: string]: unknown }): void;
	breadcrumb(data: { [key: string]: any }): void;
}

export class BugsWrapper {
	private readonly _service: BugsService;

	constructor(service: BugsService) {
		this._service = service;
	}

	public breadcrumb(data: { [key: string]: any }): void {
		this._service.breadcrumb(data);
	}

	public reportError(error: Error, options: { [key: string]: unknown }): void {
		this._service.reportError('custom-error', error, options);
	}
}
